module.exports = __webpack_public_path__ + "b51a1634be80587a757263694a3e5628.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/event-gov_grant.png
 ** module id = 1061
 ** module chunks = 0
 **/